import src from "IMAGE";
export default { src, width: 383, height: 80, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABtGMqEZOjN+PDw8NTY2Ni82NjYwKSkpJDw8PDYuLi4pABc9LqAUISR9Ozs7NDIyMio3NzcwMDAwKj09PTY2NjYv2M8N65hYXV0AAAAASUVORK5CYII=", blurWidth: 8, blurHeight: 2 }
